import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "10 10 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.377 21.175l-.99 1.012c-.792.792-1.287 1.463-1.287 3.113h-2.2v-.55c0-1.221.495-2.321 1.287-3.113l1.364-1.386A2.15 2.15 0 0024.2 18.7a2.2 2.2 0 10-4.4 0h-2.2a4.4 4.4 0 018.8 0 3.52 3.52 0 01-1.023 2.475zM23.1 29.7h-2.2v-2.2h2.2v2.2zM22 11a11 11 0 1011 11c0-6.083-4.95-11-11-11z",
    fill: "currentColor"
  })));
}

export { SvgQuestionMark as ReactComponent };
